import { render, staticRenderFns } from "./WorkflowCreate.vue?vue&type=template&id=200040f6&"
import script from "./WorkflowCreate.vue?vue&type=script&lang=js&"
export * from "./WorkflowCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports